import { Routes } from "@angular/router";
import { InitialComponent } from "./shared/initial/initial.component";
import { AuthGuard } from "./shared/auth-guards/auth.guard";
import { PageNotFoundComponent } from "./shared/error-pages/page-not-found.component";

export const rootRoutes: Routes = [
  {
    path: "",
    component: InitialComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        redirectTo: "sales",
      },
      {
        path: "sales",
        loadChildren: () =>
          import("../app/sales/sales.module").then((m) => m.SalesModule),
        data: {
          routePath: "locationItems",
          topHeader: "SIDE_NAVIGATION.SALES",
        },
      },
      {
        path: "cashiers",
        loadChildren: () =>
          import("../app/cashier/cashier.module").then((m) => m.CashierModule),
        data: {
          routePath: "cashiers",
          topHeader: "SIDE_NAVIGATION.CASHIERS",
        },
      },
      {
        path: "reports",
        loadChildren: () =>
          import("../app/reports/reports.module").then((m) => m.ReportsModule),
        data: {
          routePath: "reports",
          topHeader: "SIDE_NAVIGATION.REPORTS",
        },
      },
      {
        path: "digital-receipts",
        loadChildren: () =>
          import("../app/digital-receipts/digital-receipts.module").then(
            (m) => m.DigitalReceiptsModule
          ),
      },
      {
        path: "sheets",
        loadChildren: () =>
          import("../app/sheets/sheets.module").then((m) => m.SheetsModule),
        data: {
          routePath: "sheets",
          topHeader: "Sheets",
        },
      },
      {
        path: "lane-reboot",
        loadChildren: () =>
          import("../app/lane-reboot/lane-reboot.module").then(
            (m) => m.LaneRebootModule
          ),
        data: {
          routePath: "lane-reboot",
          topHeader: "lane-reboot",
        },
      },
      {
        path: "transactions",
        loadChildren: () =>
          import("../app/transactions/transaction.module").then(
            (m) => m.TransactionModule
          ),
        data: {
          routePath: "transactions",
          topHeader: "Transactions",
        },
      },
      {
        path: "custom-report",
        loadChildren: () =>
          import("../app/custom-report/custom-report.module").then(
            (m) => m.CustomReportModule
          ),
        data: {
          routePath: "custom-report",
          topHeader: "Custom Report",
        },
      },
      {
        path: "analytics",
        loadChildren: () =>
          import("../app/analytics/analytics.module").then(
            (m) => m.AnalyticsModule
          ),
        data: {
          routePath: "analytics",
          topHeader: "Analytics",
        },
      },
      {
        path: "companyDepartments",
        loadChildren: () =>
          import("../app/company-department/company-department.module").then(
            (m) => m.CompanyDepartmentModule
          ),
      },
      {
        path: "userProfile",
        loadChildren: () =>
          import("../app/user-profile/user-profile.module").then(
            (m) => m.UserProfileModule
          ),
        data: {
          routePath: "userProfile",
          topHeader: "USER_PROFILE.PROFILE",
        },
      },
      {
        path: "user-settings",
        loadChildren: () =>
          import("../app/user-settings/user-settings.module").then(
            (m) => m.UserSettingsModule
          ),
        data: {
          routePath: "user-settings",
          topHeader: "USER_SETTINGS.USER_SETTINGS",
        },
      },
      {
        path: "settings",
        loadChildren: () =>
          import("../app/settings/settings.module").then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: "balancing",
        loadChildren: () =>
          import("../app/truview-balance/truview-balance.module").then(
            (m) => m.TruviewBalanceModule
          ),
      },
      {
        path: "sales-v2",
        loadChildren: () =>
          import(
            "../app/data-point-reporting/data-point-reporting.module"
          ).then((m) => m.DataPointReportingModule),
      },
      {
        path: "double-up-report",
        loadChildren: () =>
          import("../app/double-up-report/double-up-report.module").then(
            (m) => m.DoubleUpReportModule
          ),
        data: {
          routePath: "double-up-report",
          topHeader: "Double Up Report",
        },
      },
      {
        path: "door-scan-solution",
        loadChildren: () =>
          import("../app/door-scan-solution/door-scan-solution.module").then(
            (m) => m.DoorScanSolutionModule
          ),
        data: {
          routePath: "door-scan-solution",
          topHeader: "door-scan-solution",
        },
      },
      {
        path: "food-court-productivity",
        loadChildren: () =>
          import(
            "../app/food-court-productivity/food-court-productivity.module"
          ).then((m) => m.FoodCourtProductivityModule),
        data: {
          routePath: "food-court-productivity",
          topHeader: "food-court-productivity",
        },
      },
    ],
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import("../app/create-password/create-password.module").then(
        (m) => m.CreatePasswordModule
      ),
    data: {
      routePath: "RESET",
    },
  },
  {
    path: "create-password",
    loadChildren: () =>
      import("../app/create-password/create-password.module").then(
        (m) => m.CreatePasswordModule
      ),
  },

  {
    path: "login",
    loadChildren: () =>
      import("../app/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
